import CryptoJs from 'crypto-js';

const key = CryptoJs.enc.Hex.parse(process.env.VUE_APP_ENCRYPT_KEY);
const iv = CryptoJs.enc.Hex.parse(process.env.VUE_APP_ENCRYPT_IV);

export const encrypt = (value: string) => CryptoJs.AES.encrypt(
  value, key, { iv },
).ciphertext.toString(CryptoJs.enc.Base64);

export default encrypt;
